import { baseAPI } from '~shared/api/base-api';

export interface ExportConflictReportParams {
  recitalId: string;
  format?: 'csv' | 'pdf';
}

export const exportConflictReport = async ({
  recitalId,
  format = 'csv',
}: ExportConflictReportParams): Promise<Blob> => {
  const response = await baseAPI.get(
    `/recitals/${recitalId}/reports/conflicts`,
    {
      params: { format },
      responseType: 'blob',
    },
  );
  return response.data;
};

export const downloadConflictReport = async (
  recitalId: string,
  format: 'csv' | 'pdf' = 'csv',
): Promise<void> => {
  const blob = await exportConflictReport({ recitalId, format });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `conflict-report-${recitalId}.${format}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
